import { useTranslate } from 'react-polyglot';

import type { SessionAnalytics } from '../../../../utils/buildSessionAnalytics';
import { ColumnScrollArea } from '../common/ColumnScrollArea.styled';
import { Column, Columns } from '../common/Columns.styled';
import { SectionTitle } from '../common/SectionTitle.styled';
import { ParticipantScores } from '../ParticipantScores/ParticipantScores';
import { ResolvedQuestionList } from '../ResolvedQuestionList/ResolvedQuestionList';
import { SessionKpis } from '../SessionKpis/SessionKpis';

interface AnalyticsFullScreenProps {
  analytics: SessionAnalytics;
  onGoToSlide: (slideId: string) => void;
}

/**
 * The expanded read of the session: everything the side panel shows plus the two extra
 * indicators and the per-participant column, side by side instead of stacked behind a
 * scroll. The moment for this view is stopping to look at how it went, not presenting.
 */
export const AnalyticsFullScreen = ({
  analytics,
  onGoToSlide,
}: AnalyticsFullScreenProps) => {
  const t = useTranslate();

  const { kpis, questions, participants, scoreableQuestions } = analytics;

  return (
    <Columns>
      <Column>
        <SectionTitle>{t('__new.play.analyticsResults.summary.title')}</SectionTitle>
        <SessionKpis kpis={kpis} isExpanded />
      </Column>

      <Column>
        <SectionTitle>
          {t('__new.play.analyticsResults.questions.breakdown')}
        </SectionTitle>

        <ColumnScrollArea>
          <ResolvedQuestionList questions={questions} onGoToSlide={onGoToSlide} />
        </ColumnScrollArea>
      </Column>

      <Column>
        <ParticipantScores
          participants={participants}
          totalQuestions={scoreableQuestions}
        />
      </Column>
    </Columns>
  );
};
